import ModalHook, { useModal } from '@components/ModalHook';
import React, { useEffect, useState } from 'react';
import { Row, Col, Divider, message, Avatar} from 'antd';
import dayjs from 'dayjs';
import {
  CalendarOutlined,
  UserOutlined,
  MobileOutlined,
  MailOutlined,
  HomeOutlined,
  GlobalOutlined,
} from '@ant-design/icons';
import { renderSplitString } from '@components/Recruitment/Applicant';
import { updateViewCount, updateOpenContactCount } from '@services/userCV.service';
import { handleUpdateOpenContactCount } from "@services/userMeta.service.js";
import to from 'await-to-js';
import styles from './ResumeViewer.module.scss';
import { genderType } from './CVInfoForm';
import { useAuth } from '@components/Auth';
import { renderModifiedName } from '@components/Recruitment/Applicant';
import { createMultiUserMeta, getInfoUserMetaOfUsers } from "@services/userMeta.service.js";
import { USER_MEATA_KEY } from 'src/constants';

export const MODAL_VIEW_RESUME = "MODAL_VIEW_RESUME";

const ResumeViewer = () => {
  const { user } = useAuth();
  const [modalData, , hidePopup] = useModal(MODAL_VIEW_RESUME);
  const [stateOpenContact, setStateOpenContact] = useState({});
  
  const data = modalData?.data?.resume;
  const isViewResume = modalData?.data?.isViewResume;
  
  const getUserMeta = async (userId) => {
    const res = await getInfoUserMetaOfUsers({
      userIds: [userId],
      metaKeys: USER_MEATA_KEY.REMAINING_OPEN_CONTACT
    });
    
    //create metas for user
    if (!res?.data?.content || res?.data?.content?.length === 0) {
      createMultiUserMeta([
        {
          userId: userId,
          metaKey: USER_MEATA_KEY.REMAINING_OPEN_CONTACT,
          metaValue: 18,
        },
        {
          userId: userId,
          metaKey: USER_MEATA_KEY.TOTAL_OPEN_CONTACT,
          metaValue: 0,
        }
      ]);
      return 18;
    };

    const countRes = res.data.content[0].metaValue;
    return parseInt(countRes);
  };

  useEffect(() => {
    if (!isViewResume) return;

    updateViewResumeCount();
  }, [isViewResume]);

  if (!data) {
    return <div></div>;
  };

  //update view resume count
  const updateViewResumeCount = async () => {
    const [error, res] = await to(updateViewCount(data.id));
    if (error) return;
    if (res?.data) {
      const setViewResume = modalData.data.setViewResume;
      setViewResume(res.data);
    }
  };

  //handle open contact
  const handleOpenContact = async () => {
    const count = await getUserMeta(user.id);

    if (count <= 0) {
      message.error("Bạn đã hết lượt mở liên hệ. Vui lòng liên hệ support để nhận thêm!");
      return;
    };

    const newStateOpenContact = {...stateOpenContact};
    newStateOpenContact[data.id] = true;
    setStateOpenContact(newStateOpenContact);
    //update resume's total open contact
    const [, res] = await to(updateOpenContactCount(data.id));
    if (res?.data) {
      const setOpenContactResumeCount = modalData.data.setOpenContactResumeCount;
      setOpenContactResumeCount(res.data);
    };
    //update user's open contact count 
    const [, response] = await to(handleUpdateOpenContactCount(user.id));
  };

  const {
    name, 
    profession, 
    birthDate, 
    avatarUrl, 
    gender, 
    phoneNumber, 
    email, 
    address, 
    personalLink, 
    careerGoals, 
    education, 
    experience, 
    certificate 
  } = data;

  const modifiedName = renderModifiedName(name);
  const experienceRender = JSON.parse(experience);
  const educationRender = JSON.parse(education);
  
  return (
    <ModalHook
      id={MODAL_VIEW_RESUME}
      onCancel={hidePopup}
      width={930}
      closable={false}
      
    >
      <div className={styles["vn-rb-cv-info-form"]}>
        <Row gutter={24}>
          <Col xs={24} sm={24} md={8} className={styles['personal-info']}>
            <div className={styles.name}>{modifiedName}</div>

            <div className={styles.career}>{profession}</div>

            <div className={styles['avatar-wrapper']}>
              <Avatar size={168} src={avatarUrl} />
            </div>

            <div className="contact-info">
              <p className={styles['title']}>Thông tin liên hệ</p>
              {stateOpenContact[data.id]
                ? <div className={styles.contactInfo}>
                    <div className={styles.contact}>
                      <CalendarOutlined /> 
                      {dayjs(birthDate).format('DD/MM/YYYY')}
                    </div>

                    <div className={styles.contact}>
                      <UserOutlined />
                      {genderType[gender].value}
                    </div>

                    <div className={styles.contact}>
                      <MobileOutlined />
                      {phoneNumber} 
                    </div>

                    <div className={styles.contact}>
                      <MailOutlined />
                      {email}
                    </div>

                    <div className={styles.contact}>
                      <  HomeOutlined />
                      {address}
                    </div>

                    <div className={styles.contact}>
                      <GlobalOutlined />
                      {personalLink}
                    </div>
                  </div>
                : <div className={styles.contactInfo}>
                    <div className={styles.blur}>
                      <div 
                        onClick={handleOpenContact}
                        className={styles.buttonOpenContact}
                      >
                          Xem
                      </div>
                    </div>
                    <div className={styles.contact}>
                      <CalendarOutlined /> 
                      01/01/2000
                    </div>

                    <div className={styles.contact}>
                      <UserOutlined />
                      Nữ
                    </div>

                    <div className={styles.contact}>
                      <MobileOutlined />
                      0123456789
                    </div>

                    <div className={styles.contact}>
                      <MailOutlined />
                      aabc@gmail.com
                    </div>

                    <div className={styles.contact}>
                      <HomeOutlined />
                      123 Nguyễn Du, quận 1
                    </div>

                    <div className={styles.contact}>
                      <GlobalOutlined />
                      abc.com
                    </div>
                  </div>
              }

            </div>

            <Divider className={styles['divider']} />
          </Col>

          <Col xs={24} sm={24} md={16}>
            <p className={styles['title']}>Mục tiêu nghề nghiệp</p>
            <div>{renderSplitString(careerGoals)}</div>
            <Divider className={styles['divider']} />

            <p className={styles['title']}>Học vấn</p>
            <ul className={styles.listEducate}>
              {educationRender.map((item, index) => {
                return (
                  <li key={index}>
                    <span className={styles.schoolName}><b>{item.shoolName}</b></span>
                    <span className={styles.rangeTime}><i>({dayjs(item.rangeTime[0]).format('DD/MM/YYYY')} - {dayjs(item.rangeTime[1]).format('DD/MM/YYYY')})</i></span>
                    <div>{item.description}</div>
                  </li>
                )
              })}
            </ul>

            <Divider className={styles['divider']} />

            <p className={styles['title']}> Kinh nghiệm làm việc</p>
            
            <ul className={styles.listExperience}>
              {experienceRender.map((item, index) => {
                return (
                  <li key={index}>
                    <div>
                      <span className={styles.jobTitle}><b>{item.title}: </b></span>
                      <span><b>{item.companyName}</b></span>
                      <span className={styles.rangeTime}><i>({dayjs(item.rangeTime[0]).format('DD/MM/YYYY')} - {dayjs(item.rangeTime[1]).format('DD/MM/YYYY')})</i></span>
                    </div>
                    <div>
                      {renderSplitString(item.description)}
                    </div>
                  </li>
                )
              })}
            </ul>
            
            <Divider className={styles['divider']} />

            <p className={styles['title']}>Chứng chỉ</p>
            <div>{renderSplitString(certificate)}</div>
            <Divider className={styles['divider']} />
          </Col>
        </Row>
      </div>
    </ModalHook>
    
  );
};

export default ResumeViewer;
